import React, { useState } from 'react';
import withStyles from '@mui/styles/withStyles';
import CardContent from '@mui/material/CardContent';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';

import SearchIcon from '@mui/icons-material/Search';
import SearchActiveForm from '../SearchActiveForm';

import SearchForeclosureForm from '../SearchForeclosureForm';
import { blue } from '@mui/material/colors';

const styles = (theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		flex: 1,
		color: blue[900],
		margin: 10,
		justifyContent: 'center',
		alignSelf: 'center'
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	}
});

const DialogTitle = withStyles(styles)(({ children, classes, onClose, ...other }) => {
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

export default function Search({ handleSearch, handleRefreshSearch, areaOptionsQuery }) {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<CardContent className={styles.root}>
				<Grid container justifyContent="center" alignItems="center">
					<IconButton onClick={handleClickOpen} size="large">
						<Fab component="span" className={styles.button}>
							<SearchIcon />
						</Fab>
					</IconButton>
					<Dialog open={open} onClose={handleClose} aria-labelledby="search">
						<DialogTitle id="search" onClose={handleClose}>
							{'Search Foreclosure Listings'}
						</DialogTitle>
						<DialogContent dividers>
							<SearchForeclosureForm
								areaOptionsQuery={areaOptionsQuery}
								handleSearch={handleSearch}
								handleClose={handleClose}
								handleRefreshSearch={handleRefreshSearch}
							/>
						</DialogContent>
					</Dialog>
				</Grid>
			</CardContent>
		</React.Fragment>
	);
}
